import { render, staticRenderFns } from "./buyerRemark.vue?vue&type=template&id=74e90d42&scoped=true"
import script from "./buyerRemark.vue?vue&type=script&lang=js"
export * from "./buyerRemark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e90d42",
  null
  
)

export default component.exports